<template>
  <div class="container-fluid">
    <div class="row flex-md-row flex-column">
      <div class="col-md-4 col-12 custom-col-md-4 d-flex align-items-center">
        <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="images.length > 1">
          <ol class="carousel-indicators">
            <li
              v-for="(image, index) in images"
              :key="index"
              :data-target="'#myCarousel'"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img :src="image" alt="Image" class="d-block w-100" style="object-fit: cover;" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div v-else>
          <img :src="images[0]" alt="Image" class="d-block w-100" style="object-fit: cover;" />
        </div>
      </div>
      <div class="col-md-6 col-12 custom-col-md-6">
        <h4>{{ title }}</h4><br />
        <p class="text-dark-gray" v-html="description"></p>
      </div>
    </div>
  </div>
  
</template>


<script>
export default {
  data() {
    return {
      images: [
        require('@/assets/images/news/01/news_01.jpg'),
        //可輪播圖片
        //EX:require('@/assets/images/news/01/news_3.png'),
      ],
      //標題
      title: '【 TSK |  仿冒提醒聲明 】',
      //內文
      description:
        '⚠️ 注意！ 防範TSK仿冒品！ ⚠️<br>親愛的客戶和合作夥伴：<br>最近TSK發現國外市面上出現冒充TSK製造或貼有假TSK標籤的產品。仿冒品並不符合醫療器材的品質標準，可能導致操作問題和安全影響。<br>為了保護您的權益，請確認購買管道是否為TSK官方授權的代理商，對於因使用仿冒品而可能發生的任何操作問題或損壞，TSK將不承擔任何責任。<br><br>🔍 如何辨別真偽：<br>① 仿冒品的產品名稱無“TSK”字樣。<br>② 仿冒品的製造商地址無“TSK LABORATORY”字樣。<br>③ 製造商正確地址為“Tochigi-Ken”，“Tochigi-Kan”為仿冒品。<br><br>🌐 獲取更多資訊：<br>請關注TSK官方網站和追蹤官方社群媒體，以了解更多TSK資訊。<br><br>感謝您對 TSK 的支持與信任，未來TSK將繼續努力提供安全、可靠、高品質的產品和服務。<br><br>日本TSK聲明連結：<a href="https://www.tsklab.co.jp/en/news/2024/02/274/"target="_blank">https://www.tsklab.co.jp/en/news/2024/02/274/</a> ',
    };
  },
};
</script>

<style scoped>
.custom-col-md-4 {
  flex: 0 0 auto;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-col-md-6 {
  flex: 0 0 auto;
  width: 60%;
}
@media (max-width: 767.98px) {
  .custom-col-md-4,
  .custom-col-md-6 {
    flex: 0 0 auto;
    width: 100%;
  }
}
</style>
